import { userConstants } from './user.constants'

const userState = {
  loadingDocumentsForUser: false,
  documentsForUser: [],
  loading: false,
  savingUserDocuments: {
    totalNumberOfDocuments: 0,
    totalSavedDocuments: 0,
  },
}

export function user(state = userState, action) {
  switch (action.type) {
    case userConstants.GET_DOCUMENTS_FOR_USER_LOADING:
      return {
        ...state,
        loadingDocumentsForUser: true,
      }
    case userConstants.GET_DOCUMENTS_FOR_USER_SUCCESS:
      return {
        ...state,
        loadingDocumentsForUser: false,
        documentsForUser: action.documentsForUser,
      }
    case userConstants.GET_DOCUMENTS_FOR_USER_ERROR:
      return {
        ...state,
        loadingDocumentsForUser: false,
      }
    case userConstants.REQUEST_START:
      return {
        ...state,
        loading: true,
      }
    case userConstants.REQUEST_STOP:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}
